module.exports = __webpack_public_path__ + "static/media/inside_alcatraz.094fc996.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/books/originals/inside_alcatraz.jpg
// module id = 109
// module chunks = 0